import { BaseResource } from 'utils/ApiUtils';

export default class InspectionView extends BaseResource {
    constructor(args) {
        super(args, InspectionView.attributes);
    };


    static columns = [
        { title: "Resource", field: "Resource", type: "string" },
        { title: "Manager", field: "Manager", type: "string" },
        { title: "Status", field: "Status", type: "string" },
        {
            title: "Inspector Tracking Date",
            field: "OccurenceDate",
            type: "date",
            filter: true,
            sorting: true,
            render: rowData => {
                if (!rowData.OccurenceDate) return '';
                return new Date(rowData.OccurenceDate).toLocaleDateString();
            }
        },
        {
            title: "Time In",
            field: "TimeIn",
            type: "date",
            filter: true,
            sorting: false,
            render: rowData => new Date(rowData.TimeIn).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })

        },
        {
            title: "Time Out",
            field: "TimeOut",
            type: "date",
            filter: true,
            sorting: false,
            render: rowData => new Date(rowData.TimeOut).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        },
        { title: "Total Hours", field: "TotalHours", type: "string", filter: false, sorting: false },
        { title: "Date Entered", field: "DateEntered", type: "date", defaultSort: "desc" },
        { title: "Date Completed", field: "DateCompleted", type: "date" },
        { title: "Last Updated", field: "LastUpdateDate", type: "date" },
        { title: "Inspection Number", field: "InspectionNumber", sorting: true, type: "string" },
        { title: "Inspection Id", field: "InspectionId", sorting: false, type: "string", hidden: true },
        { title: "QC Name", field: "QCName", sorting: true, type: "string", hidden: false },
        { title: "Comments", field: "Comments", sorting: false, type: "boolean", hidden: false },
        { title: "QC Comments", field: "QcComments", sorting: false, type: "string", hidden: true },
        { title: "Field Test", field: "HasFieldTest", sorting: false, type: "boolean", hidden: false },
        { title: "Samples", field: "HasSample", sorting: false, type: "boolean", hidden: false },
        { title: "Checklist", field: "HasChecklist", sorting: false, type: "boolean", hidden: false },
   


    ]
    static attributes = InspectionView.columns.map(r => r.field);

    static expand = [];

};